<div id="container">
    <ng-container *ngFor="let violation of getViolations()">
        <div class="violation" [ngClass]="colorize(violation)">
            <div class="no-copy" [innerHTML]="getViolationSymbol(violation)"></div>
        </div>
    </ng-container>
</div>